import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./Layout";
import { AppState } from "./reducers";
import Auth from "./services/Auth/Auth";
import Spinner from "./components/Spinner";
// import { useTranslation } from "react-i18next";

const Home = React.lazy(() => import("./views/Home/home"));
const Performance = React.lazy(() => import("./views/Performance"));
const Drivers = React.lazy(() => import("./views/Drivers"));
const Vehicles = React.lazy(() => import("./views/Vehicles"));
const FormView = React.lazy(() => import("./views/FormView"));
const Profil = React.lazy(() => import("./views/FormView"));
const Earnings = React.lazy(() => import("./views/Revenues"));
const Payments = React.lazy(() => import("./views/Paiements"));
const Error = React.lazy(() => import("./views/404/404"));

function App() {

  const { isConnected } = useSelector((state: AppState) => state.account);

  const { intl } = useSelector((state: AppState) => state.intl);

  const ProtectedRoute = ({ children }) => {

    if (!isConnected) {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  const IsLoginRoute = ({ children }) => {

    if (isConnected) {
      return <Navigate to="/performance" replace />;
    }
    return children;
  };

  return (
    <div className="App">
      <div dir={intl === 'ar' ? 'rtl' : 'ltr'}>
        <BrowserRouter>
          <Auth>
            <Layout>
              <Suspense fallback={isConnected && <Spinner />}>
                <Routes>
                  <Route path="/" element={
                    <IsLoginRoute>
                      <Home />
                    </IsLoginRoute>
                  } />
                  <Route
                    path="/performance"
                    element={
                      <ProtectedRoute>
                        <Performance />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/chauffeurs"
                    element={
                      <ProtectedRoute>
                        <Drivers />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vehicules"
                    element={
                      <ProtectedRoute>
                        <Vehicles />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/:type/form/:id?"
                    element={
                      <ProtectedRoute>
                        <FormView />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/driver/:driverId"
                    element={
                      <ProtectedRoute>
                        <Profil />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/revenues"
                    element={
                      <ProtectedRoute>
                        <Earnings />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/paiements/:cycle?/:idPay?"
                    element={
                      <ProtectedRoute>
                        <Payments />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="*" element={<Error />} />
                </Routes>
              </Suspense>
            </Layout>
          </Auth>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
